<template>
  <div>
    <div
      v-if="detail.content === '$[輸入貼文按讚連結]'"
      class="mb-2"
    >
      您好，請輸入您的FB個人頁分享貼文連結網址，我們將會為您發放獎勵。
    </div>
    <div
      v-if="detail.content === '$[輸入粉絲專頁按讚連結]'"
      class="mb-2"
    >
      您好，請輸入您的FB個人頁「關於」連結網址，我們將會為您發放獎勵。
    </div>
    <div
      v-if="detail.content === '$[輸入買即可粉絲專頁按讚連結]'"
      class="mb-2"
    >
      您好，請輸入您的FB個人頁「關於」連結網址，我們將會為您發放獎勵。
    </div>
    <v-layout
      align-center
      class="InputTracnkingNo ma-0"
    >
      <v-text-field
        v-model="inputVal"
        :disabled="hasReply || disabled"
        :placeholder="`請貼上連結`"
        outlined
        hide-details
        class="mt-0 pt-0"
        @keyup.enter="submit"
      />
      <v-btn
        v-if="!hasReply && !disabled"
        color="info"
        class="ml-2 mt-4"
        small
        @click="submit"
      >
        送出
      </v-btn>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    detail: Object,
    parent: Object,
    disabled: Boolean,
  },
  data () {
    return {
      inputVal: '',
      hasReply: false,
      loading: false,
    }
  },
  computed: {
    type () {
      // return this.detail.content ===  ? 'postLike' : 'groupLike'
      return {
        '$[輸入貼文按讚連結]': 'postLike',
        '$[輸入粉絲專頁按讚連結]': 'groupLike',
        '$[輸入買即可粉絲專頁按讚連結]': 'magicbuyLike',
      }[this.detail.content]
    },
  },
  watch: {
    parent () {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const index = this.parent.replies.findIndex(item => item.content.indexOf(`[${this.detail.cid}]`) > -1)
      if (index > -1) {
        this.hasReply = true
        this.inputVal = this.parent.replies[index].content.split('：')[1]
        this.parent.replies.splice(index, 1)
      }
    },
    async submit () {
      if (!this.inputVal) return
      try {
        this.loading = true
        const coinRes = await this.$store.dispatch('coin/facebook/reissueLinksCreate', {
          link: this.inputVal,
          type: this.type,
          cid: this.parent.cid,
        })
        if (coinRes.data.error) return

        const res = await this.$store.dispatch('comment/createReply', {
          content: `回覆[${this.detail.cid}]${this.type}：${this.inputVal}`,
          upyunFiles: [],
          parent: this.parent.cid,
        })
        if (!res.data.error) {
          this.$emit('reload')
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="postcss">
.InputTracnkingNo {
  .v-input .v-label {
    font-size: 14px;
  }
}
</style>
